import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { Flow } from './components';

const Flow = lazy(()=> import(/* webpackChunkName: "flow" */ './components/Flow'))

const routes = () => <PrivateRoute exact path="/flow" component={Flow} />;

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/flow/Flow/routes.js